import React from "react";
import { Link } from "react-router-dom";

const Back = (props) => {
  const { to, state, onClick, className, name } = props;

  if (onClick) {
    // 🟡 Case 1: If onClick is provided — render a button
    return (
      <button
        type="button"
        onClick={onClick}
        className={`txt-dark underline-none bg-transparent border-0 p-0 ${className || ""}`}
        style={{ cursor: "pointer" }}
      >
        <span className="new_back">
          <svg
            width="14"
            height="12"
            viewBox="0 0 14 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.0026 5.33333H3.27856L6.80723 1.80467L5.86456 0.862L0.726562 6L5.86456 11.138L6.80723 10.1953L3.27856 6.66667H13.0026V5.33333Z"
              fill="#5C5F62"
            />
          </svg>
        </span>
      </button>
    );
  }


  return (
    <Link
      to={{ pathname: to, state }}
      className={`txt-dark underline-none ${className || ""}`}
    >
      <span className="new_back">
        <svg
          width="14"
          height="12"
          viewBox="0 0 14 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.0026 5.33333H3.27856L6.80723 1.80467L5.86456 0.862L0.726562 6L5.86456 11.138L6.80723 10.1953L3.27856 6.66667H13.0026V5.33333Z"
            fill="#5C5F62"
          />
        </svg>
      </span>
      &nbsp;
      {props.name}
    </Link>
  );
};

export default Back;
